import {useMemo} from 'react';
import type {Schema} from 'schemaDefinition/types';
import type {ThesaurusId} from 'services/thesaurus/types';
import {visitSchemaParts} from 'schemaDefinition/functions';

export const useSchemaThesaurusIds = (
  schema: Schema | undefined,
): ThesaurusId[] => {
  return useMemo(() => {
    const thesaurusIds: ThesaurusId[] = [];

    if (!schema) {
      return [];
    }
    visitSchemaParts(schema, part => {
      switch (part.type) {
        case 'thesaurus': {
          if (!thesaurusIds.includes(part.thesaurusId)) {
            thesaurusIds.push(part.thesaurusId);
          }
          break;
        }
      }
    });

    return thesaurusIds;
  }, [schema]);
};
